export default {
  path: '/salePurchase',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'saleOverview',
      name: 'saleOverview',
      component: () => import('@/pages/purchaseSalesCenter/saleManage/index.vue'),
      meta: {
        keepAlive: true,
        title: '销售总览查询',
      },
    },
    // {
    //   path: 'serviceOverview',
    //   name: 'serviceOverview',
    //   component: serviceOverview,
    //   meta: {
    //     keepAlive: true,
    //     title: '服务合同总览查询',
    //   },
    // },
    // {
    //   path: 'premiumOverview',
    //   name: 'premiumOverview',
    //   component: premiumOverview,
    //   meta: {
    //     keepAlive: true,
    //     title: '升贴水合同总览查询',
    //   },
    // },
    // {
    //   path: 'saleIntent',
    //   name: 'saleIntent',
    //   component: saleIntent,
    //   meta: {
    //     keepAlive: true,
    //     title: '销售意向单创建',
    //   },
    // },
    // {
    //   path: 'saleIntentEdit',
    //   name: 'saleIntentEdit',
    //   component: saleIntentEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '销售意向单修改',
    //   },
    // },
    // {
    //   path: 'singleSale',
    //   name: 'singleSale',
    //   component: singleSale,
    //   meta: {
    //     keepAlive: true,
    //     title: '单次销售合同创建',
    //   },
    // },
    // {
    //   path: 'serviceAdd',
    //   name: 'serviceAdd',
    //   component: serviceAdd,
    //   meta: {
    //     keepAlive: true,
    //     title: '服务合同创建',
    //   },
    // },
    // {
    //   path: 'serviceEdit',
    //   name: 'serviceEdit',
    //   component: serviceEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '服务合同修改',
    //   },
    // },
    // {
    //   path: 'premiumAdd',
    //   name: 'premiumAdd',
    //   component: premiumAdd,
    //   meta: {
    //     keepAlive: true,
    //     title: '升贴水合同创建',
    //   },
    // },
    // {
    //   path: 'premiumEdit',
    //   name: 'premiumEdit',
    //   component: premiumEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '升贴水合同修改',
    //   },
    // },
    // {
    //   path: 'singleSaleEdit',
    //   name: 'singleSaleEdit',
    //   component: singleSaleEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '单次销售合同修改',
    //   },
    // },
    // {
    //   path: 'yearSale',
    //   name: 'yearSale',
    //   component: yearSale,
    //   meta: {
    //     keepAlive: true,
    //     title: '年度销售协议创建',
    //   },
    // },
    // {
    //   path: 'yearSaleEdit',
    //   name: 'yearSaleEdit',
    //   component: yearSaleEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '年度销售协议修改',
    //   },
    // },
    // {
    //   path: 'monthSale',
    //   name: 'monthSale',
    //   component: monthSale,
    //   meta: {
    //     keepAlive: true,
    //     title: '月度销售协议创建',
    //   },
    // },
    // {
    //   path: 'monthSaleEdit',
    //   name: 'monthSaleEdit',
    //   component: monthSaleEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '月度销售协议修改',
    //   },
    // },
    {
      path: 'purchaseOverview',
      name: 'purchaseOverview',
      component: () => import('@/pages/purchaseSalesCenter/purchaManage/index.vue'),
      meta: {
        keepAlive: true,
        title: '采购总览查询',
      },
    },
    // {
    //   path: 'purchaseIntent',
    //   name: 'purchaseIntent',
    //   component: purchaseIntent,
    //   meta: {
    //     keepAlive: true,
    //     title: '采购意向单创建',
    //   },
    // },
    // {
    //   path: 'singlePurchaseContract',
    //   name: 'singlePurchaseContract',
    //   component: singlePurchaseContract,
    //   meta: {
    //     keepAlive: true,
    //     title: '单次采购合同创建',
    //   },
    // },
    // {
    //   path: 'monthPurchase',
    //   name: 'monthPurchase',
    //   component: monthPurchase,
    //   meta: {
    //     keepAlive: true,
    //     title: '月度采购协议创建',
    //   },
    // },
    // {
    //   path: 'monthPurchaseEdit',
    //   name: 'monthPurchaseEdit',
    //   component: monthPurchaseEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '月度采购协议修改',
    //   },
    // },
    // {
    //   path: 'yearPurchase',
    //   name: 'yearPurchase',
    //   component: yearPurchase,
    //   meta: {
    //     keepAlive: true,
    //     title: '年度采购协议创建',
    //   },
    // },
    // {
    //   path: 'yearPurchaseEdit',
    //   name: 'yearPurchaseEdit',
    //   component: yearPurchaseEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '年度采购协议修改',
    //   },
    // },
    // {
    //   path: 'purchaseIntentEdit',
    //   name: 'purchaseIntentEdit',
    //   component: purchaseIntentEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '采购意向单修改',
    //   },
    // },
    // {
    //   path: 'singlePurchaseContractEdit',
    //   name: 'singlePurchaseContractEdit',
    //   component: singlePurchaseContractEdit,
    //   meta: {
    //     keepAlive: true,
    //     title: '单次采购合同修改',
    //   },
    // },
    // 物贸销售提单
    {
      path: 'materialSalesLadingbill',
      name: 'materialSalesLadingbill',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/materialSalesLadingbill/list.vue'),
      meta: {
        keepAlive: true,
        title: '销售提单查询',
      },
    },
    {
      path: 'materialSalesLadingbillAdd',
      name: 'materialSalesLadingbillAdd',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/materialSalesLadingbill/add.vue'),
      meta: {
        keepAlive: true,
        title: '销售提单创建',
      },
    },
    {
      path: 'materialSalesLadingbillEdit',
      name: 'materialSalesLadingbillEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/materialSalesLadingbill/edit.vue'),
      meta: {
        keepAlive: true,
        title: '销售提单编辑',
      },
    },
    {
      path: 'salesLadingbill',
      name: 'salesLadingbill',
      component: () => import('@/pages/purchaseSalesCenter/saleManage/billIndex.vue'),
      meta: {
        keepAlive: true,
        title: '销售提单查询',
      },
    },
    {
      path: 'salesLadingbillAdd',
      name: 'salesLadingbillAdd',
      component: () => import('@/pages/purchaseSalesCenter/saleManage/salesLadingbill/add.vue'),
      meta: {
        keepAlive: true,
        title: '销售提单创建',
      },
    },
    {
      path: 'salesLadingbillEdit',
      name: 'salesLadingbillEdit',
      component: () => import('@/pages/purchaseSalesCenter/saleManage/salesLadingbill/edit.vue'),
      meta: {
        keepAlive: true,
        title: '销售提单编辑',
      },
    },
    //新加path
    {
      path: 'purchaseAgreementCreation',
      name: 'purchaseAgreementCreation',
      component: () =>
        import('@/pages/purchaseSalesCenter/purchaManage/chengkuang/purchaseAgreementCreation.vue'),
      meta: {
        keepAlive: true,
        title: '采购协议创建',
      },
    },

    {
      path: 'purchaseAgreementEdit',
      name: 'purchaseAgreementEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/purchaManage/chengkuang/purchaseAgreementCreation.vue'),
      meta: {
        keepAlive: true,
        title: '采购协议编辑',
      },
    },
    // 物贸
    {
      path: 'wumaoAgreementCreate',
      name: 'wumaoAgreementCreate',
      component: () => import('@/pages/purchaseSalesCenter/purchaManage/wumao/AgreementDetail.vue'),
      meta: {
        keepAlive: true,
        title: '采购协议创建',
      },
    },
    {
      path: 'wumaoAgreementEdit',
      name: 'wumaoAgreementEdit',
      component: () => import('@/pages/purchaseSalesCenter/purchaManage/wumao/AgreementDetail.vue'),
      meta: {
        keepAlive: true,
        title: '采购协议编辑',
      },
    },
    {
      path: 'purchaseContractCreation',
      name: 'purchaseContractCreation',
      component: () =>
        import('@/pages/purchaseSalesCenter/purchaManage/chengkuang/purchaseContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '采购合同创建',
      },
    },
    {
      path: 'purchaseContractEdit',
      name: 'purchaseContractEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/purchaManage/chengkuang/purchaseContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '采购合同编辑',
      },
    },
    // 物贸
    {
      path: 'wumaoContractCreate',
      name: 'wumaoContractCreate',
      component: () => import('@/pages/purchaseSalesCenter/purchaManage/wumao/ContractDetail.vue'),
      meta: {
        keepAlive: true,
        title: '采购合同创建',
      },
    },
    {
      path: 'wumaoContractEdit',
      name: 'wumaoContractEdit',
      component: () => import('@/pages/purchaseSalesCenter/purchaManage/wumao/ContractDetail.vue'),
      meta: {
        keepAlive: true,
        title: '采购合同编辑',
      },
    },
    {
      path: 'saleAgreementCreation',
      name: 'saleAgreementCreation',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/chengkuang/saleAgreementCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售协议创建',
      },
    },
    {
      path: 'saleAgreementEdit',
      name: 'saleAgreementEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/chengkuang/saleAgreementCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售协议编辑',
      },
    },
    {
      path: 'saleContractCreation',
      name: 'saleContractCreation',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/chengkuang/saleContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售合同创建',
      },
    },
    {
      path: 'saleContractEdit',
      name: 'saleContractEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/chengkuang/saleContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售合同编辑',
      },
    },
    {
      path: 'wumaoSaleAgreementCreation',
      name: 'wumaoSaleAgreementCreation',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/wumao/saleAgreementCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售协议创建',
      },
    },
    {
      path: 'wumaoSaleAgreementEdit',
      name: 'wumaoSaleAgreementEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/wumao/saleAgreementCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售协议编辑',
      },
    },
    {
      path: 'wumaoSaleContractCreation',
      name: 'wumaoSaleContractCreation',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/wumao/saleContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售合同创建',
      },
    },
    {
      path: 'wumaoSaleContractEdit',
      name: 'wumaoSaleContractEdit',
      component: () =>
        import('@/pages/purchaseSalesCenter/saleManage/wumao/saleContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '销售合同编辑',
      },
    },
    {
      path: 'bilateralContract',
      name: 'bilateralContract',
      component: () =>
        import('@/pages/purchaseSalesCenter/bilateralContract/bilateralContractList/index.vue'),
      meta: {
        keepAlive: true,
        title: '双边合同',
      },
    },
    {
      path: 'bilateralContractCreate',
      name: 'bilateralContractCreate',
      component: () =>
        import('@/pages/purchaseSalesCenter/bilateralContract/bilateralContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '双边合同创建新单',
      },
    },
    {
      path: 'bilateralContractDetail',
      name: 'bilateralContractDetail',
      component: () =>
        import('@/pages/purchaseSalesCenter/bilateralContract/bilateralContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '双边合同详情',
      },
    },
    //服务合同
    {
      path: 'serviceContractList',
      name: 'serviceContractList',
      component: () =>
        import('@/pages/purchaseSalesCenter/serviceContract/serviceContractList/index.vue'),
      meta: {
        keepAlive: true,
        title: '服务合同列表',
      },
    },
    {
      path: 'serviceContractDetail',
      name: 'serviceContractDetail',
      component: () =>
        import('@/pages/purchaseSalesCenter/serviceContract/serviceContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '服务合同维护',
      },
    },
    // 供货明细表导入
    {
      path: 'supplyDetailImport',
      name: 'supplyDetailImport',
      component: () =>
        import('@/pages/purchaseSalesCenter/supplyDetail/supplyDetailImport/index.vue'),
      meta: {
        keepAlive: true,
        title: '供货明细表导入入库',
      },
    },
    // 供货明细表导出
    {
      path: 'supplyDetailExport',
      name: 'supplyDetailExport',
      component: () =>
        import('@/pages/purchaseSalesCenter/supplyDetail/supplyDetailExport/index.vue'),
      meta: {
        keepAlive: true,
        title: '供货明细表导入出库',
      },
    },
  ],
};
